import axios from 'axios';
import { serverUrl } from '../../other/constants';
import { IAnswer, IUserInfo } from '../entities';

export const trySendAnswers = async (data: { userInfo: IUserInfo, answers: IAnswer[] }) => {
  try {
    await axios.post(`${serverUrl}/testing/collectAnswers`, data);
    return true;
  } catch(error: any) {
    return false;
  }
};
